import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { URLS } from '../../constant/url-schema.constant';
import { UserPreferenceService } from '../../utils/user-preference.service';
import { LoginService } from './login.service';
import { Token } from './user.model';

export const IsSignedInGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const loginService = inject(LoginService);
  const preferenceService = inject(UserPreferenceService);
  const router = inject(Router);

  return loginService.authorize().pipe(
    switchMap((token: Token) => {
      if (!token) {
        return of(
          router.createUrlTree([`/${URLS.LOGIN}`], { queryParams: { returnUrl: state.url } })
        );
      }

      // The page reads the user cache as it renders: it has to hold the server state by then.
      return preferenceService.hydrate().pipe(map(() => true));
    })
  );
};
